__turbopack_context__.v({
  "daysOfRainRow": "bUIrva_daysOfRainRow",
  "monthName": "bUIrva_monthName",
  "row": "bUIrva_row",
  "waterIcon": "bUIrva_waterIcon",
  "waterTemperatureRow": "bUIrva_waterTemperatureRow",
});
